var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 190,
    viewBox: "0 0 343 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 190,
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 203.217V168.279C6.24263 174.117 39.8815 182.674 141.382 182.674C205.514 182.674 243.926 177.658 274.169 173.709C299.402 170.414 318.948 167.862 343 169.585V203.217H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114 71H240L241 78H115L114 71Z",
    fill: "#FFF06A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 78,
    width: 126,
    height: 84,
    fill: "#FFBF60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 83,
    width: 116,
    height: 74,
    rx: 1,
    fill: "#FF7078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 46C114 46 115 67.5 115 78L102 72C102.167 63.5 103.2 46 108 46Z",
    fill: "#FFD467"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 84,
    transform: "matrix(-1 0 0 1 241 78)",
    fill: "#FD9061"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 74,
    rx: 1,
    transform: "matrix(-1 0 0 1 238 83)",
    fill: "#D35180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 46C103.2 46 102.167 63.5 102 72H228C228.167 63.5 229.2 46 234 46H108Z",
    fill: "#FFBF60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 46C108.387 46 107.253 58.4666 107.024 66.9828C107.009 67.5425 107.46 68 108.02 68H222.019C222.564 68 223.008 67.5661 223.023 67.0217C223.25 58.5046 224.38 46 229 46H113Z",
    fill: "#FF7078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 46C240 46 241 67.5 241 78L228 72C228.167 63.5 229.2 46 234 46Z",
    fill: "#FD9061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.231 52C237.207 52 237.899 63.4068 237.989 70.3337C237.999 71.0894 237.194 71.5682 236.528 71.2113L231.538 68.5382C231.208 68.3612 231.004 68.0166 231.012 67.6419C231.133 62.1479 231.741 52 234.231 52Z",
    fill: "#D35180"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 88,
    width: 19,
    height: 34,
    rx: 9.5,
    fill: "url(#paint1_radial)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 89,
    width: 17,
    height: 32,
    rx: 8.5,
    fill: "#FFD467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.609 104.476C171.031 103.72 172 102.223 172 100.5C172 98.0147 169.985 96 167.5 96C165.015 96 163 98.0147 163 100.5C163 102.223 163.969 103.72 165.391 104.476L163.356 111.73C163.177 112.368 163.657 113 164.319 113H170.681C171.343 113 171.823 112.368 171.644 111.73L169.609 104.476Z",
    fill: "#D35180"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M153.569 114.694C152.593 113.717 152.729 111.998 153.874 110.853L164.655 100.072C165.8 98.9273 167.519 98.7906 168.496 99.7669C169.472 100.743 169.335 102.463 168.19 103.608L157.41 114.388C156.265 115.533 154.545 115.67 153.569 114.694Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144 90C141.281 90 138.985 91.5 137.44 93.5961C135.895 95.6929 135 98.4939 135 101.5C135 104.506 135.895 107.307 137.44 109.404C138.985 111.5 141.281 113 144 113C146.719 113 149.015 111.5 150.56 109.404C151.666 107.903 152.439 106.04 152.789 104H166.361C167.819 104 169 102.881 169 101.5C169 100.119 167.819 99 166.361 99H152.789C152.439 96.9598 151.666 95.0975 150.56 93.5961C149.015 91.5 146.719 90 144 90ZM139 101.5C139 99.2594 139.672 97.3104 140.66 95.9689C141.649 94.6266 142.853 94 144 94C145.147 94 146.351 94.6266 147.34 95.9689C148.328 97.3104 149 99.2594 149 101.5C149 103.741 148.328 105.69 147.34 107.031C146.351 108.373 145.147 109 144 109C142.853 109 141.649 108.373 140.66 107.031C139.672 105.69 139 103.741 139 101.5Z",
    fill: "#FFF06A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 162H241L211 184H72L102 162Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 76H249",
    stroke: "#FFF06A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 76L91 76",
    stroke: "#FFF06A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.728 60.25L244.851 64",
    stroke: "#FFF06A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.468 58L95.9526 63",
    stroke: "#FFF06A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.389 90L244.602 86",
    stroke: "#FFF06A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.468 88L95.2553 84",
    stroke: "#FFF06A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0217 65.9844L91.468 68",
    stroke: "#FFF06A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 46.5L108 46.5",
    stroke: "url(#paint4_linear)",
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333 217) rotate(-151.421) scale(344.051 287.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FFA9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8481F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.5 91.5) rotate(63.8384) scale(31.753)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 169.5,
    y1: 102,
    x2: 157,
    y2: 114.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D35180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D35180",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 156.5,
    y1: 131,
    x2: 156.5,
    y2: 178.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E28CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E28CE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 110.5,
    y1: 48.0002,
    x2: 231,
    y2: 48.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF06A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FFD976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF06A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 190,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 46,
    width: 188,
    height: 138,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChest);
export default __webpack_public_path__ + "static/media/chest.afdc93e4871b1cb14e5612fd50a24fc6.svg";
export { ForwardRef as ReactComponent };